import { useState } from "react";

import { CodeTableDataModal } from "components/CodeTableDataModal/CodeTableDataModal";
import { PageHeader } from "components/ui/PageHeader";
import { TabSwitcher } from "components/ui/TabSwitcher/TabSwitcher";

import { CodeTableTab } from "./components/CodeTableTab";
import { CredentialsTab } from "./components/CredentialsTab";
import { DeadLettersTab } from "./components/DeadLettersTab";
import { HealthlinkCallsTab } from "./components/HealthlinkCallsTab";
import styles from "./HealthlinkDetailsPage.module.css";
import { TABS, useHealthlinkDetailsPage } from "./hooks/useHealthlinkDetailsPage";

const HealthlinkDetailsPage = () => {
  const {
    activeTab,
    setActiveTab,
    healthlinkPractice,
    healthlinkCredentials,
    healthlinkPracticeCredentials,
    pcrsCredentials,
    hasClinicDetailsSaved,
    hasGpDetailsSaves,
    deletePracticeCredential,
    deleteDoctorCredential,
    testLogin,
    isTestingLogin,
    calls,
    codeTable,
    deadLetters,
  } = useHealthlinkDetailsPage();

  // The count is the whole point of surfacing this tab: an unparseable message is an
  // operational signal nobody goes looking for. Zero is left off rather than shown as "(0)",
  // so the number appearing at all is the thing that draws the eye.
  const tabOptions = [
    { value: TABS.credentials, label: "Credentials" },
    { value: TABS.calls, label: "Healthlink Calls" },
    { value: TABS.codeTable, label: "Code Table" },
    {
      value: TABS.deadLetters,
      label: "Unread Messages",
      count: deadLetters.total || null,
    },
  ];

  const [selectedCodeTable, setSelectedCodeTable] = useState(null);

  return (
    <div className={styles.content}>
      <PageHeader title="Healthlink" />

      <TabSwitcher
        options={tabOptions}
        value={activeTab}
        onChange={setActiveTab}
        fullWidth
      />

      {activeTab === TABS.credentials && (
        <CredentialsTab
          healthlinkPractice={healthlinkPractice}
          healthlinkCredentials={healthlinkCredentials}
          healthlinkPracticeCredentials={healthlinkPracticeCredentials}
          pcrsCredentials={pcrsCredentials}
          hasClinicDetailsSaved={hasClinicDetailsSaved}
          hasGpDetailsSaves={hasGpDetailsSaves}
          onDeletePracticeCredential={deletePracticeCredential}
          onDeleteDoctorCredential={deleteDoctorCredential}
          onTestLogin={testLogin}
          isTestingLogin={isTestingLogin}
        />
      )}

      {activeTab === TABS.calls && <HealthlinkCallsTab {...calls} />}

      {activeTab === TABS.deadLetters && <DeadLettersTab {...deadLetters} />}

      {activeTab === TABS.codeTable && (
        <CodeTableTab {...codeTable} onViewCodeTable={setSelectedCodeTable} />
      )}

      <CodeTableDataModal
        isOpen={!!selectedCodeTable}
        onClose={() => setSelectedCodeTable(null)}
        codeTableId={selectedCodeTable?.codeTableId}
        codeTableDescription={selectedCodeTable?.description}
      />
    </div>
  );
};

export { HealthlinkDetailsPage };
